
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {sendcommandmessage, setdevicenotifytype} from '../../api/device'

export default {

name: 'childSetWatch',
directives: {TransferDom},
data () {
return {
deviceObj: '',
setting: '',

notifyWay: [], // 通知方式
locateModelArr: [{text: '基站', id: 1}, {text: 'wifi', id: 2}, {text: 'GPS', id: 3}, {text: '自动高精度', id: 4}, {text: '自动最快', id: 5}],



selectNav: '',

addressBookList: [], // 设备通讯录列表
alarmClockList: [], // 设备闹钟列表
locateObj: '', // 设备按次定位
locateList: [], // 设备按时定位列表
notifyObj: '', // 设备通知
whiteList: [], // 白名单

/* 弹窗 */

clockPeriodArr: [{text: '按年', value: 'y'}, {text: '按月', value: 'm'}, {text: '按天', value: 'd'}, {text: '只提醒一次', value: 's'}],
clockPeriodShow: false,
clockPeriodText: '按年',
clockPeriod: 0,

clockDayArr: [{text: '01'}, {text: '02'}, {text: '03'}, {text: '04'}, {text: '05'}, {text: '06'}, {text: '07'},
{text: '08'}, {text: '09'}, {text: '10'}, {text: '11'}, {text: '12'}, {text: '13'}, {text: '14'}, {text: '15'},
{text: '16'}, {text: '17'}, {text: '18'}, {text: '19'}, {text: '20'}, {text: '21'}, {text: '22'}, {text: '23'},
{text: '24'}, {text: '25'}, {text: '26'}, {text: '27'}, {text: '28'}, {text: '29'}, {text: '30'}, {text: '31'}],
clockDateText: '',
clockDate: '',
clockDateYShow: false,
clockDateMShow: false,
clockDateSShow: false,
clockMinDate: new Date(2020, 0, 1),

clockTime: '',
clockTimeShow: false,

locateMinHour: '00',
locateStartTimeShow: false,
locateEndTimeShow: false,

locateModeText: '',
locateMode: '',
locateModeShow: false,

popupShow: false,
popupObj: {
flag: 1, // 1增加 2编辑 3删除
type: '', // addressBook/alarmClock/locate/notify
title: '',
selectIdx: '', // 编辑、删除使用

phoneObj: { name: '', phone: '', url: '', imNum: '' }, // 通讯录
clockObj: { id: '', timeType: '', time: '', content: '' }, // 闹钟
locateObj: { type: 1, func: 1, num: '', time: '', mode: 0, startTime: '', endTime: '' }, // 定位
notifyObj: { type: '1', title: '', content: '' }, // 通知
whiteObj: { phone: '', time: '' } // 白名单
}
}
},
created () {

Date.prototype.format = this.validate.format
this.getStartData()
},
methods: {
getStartData () {
this.deviceObj = this.$store.getters.get_child_obj
this.setting = this.deviceObj.settingObj

this.notifyWay = this.getNotifyWay()
this.selectNav = this.getInitSelectNav()
this.alarmClockList = this.setting.alarmClockList ? this.setting.alarmClockList : (this.deviceObj.dtype === 330 ? [{id: 1, time: '00:00', weeks: [], type: 1}, {id: 2, time: '00:00', weeks: [], type: 1}, {id: 3, time: '00:00', weeks: [], type: 1}] : [])
this.addressBookList = this.setting.addressBookList ? this.setting.addressBookList : (this.deviceObj.dtype === 332 ? [{name: '', phone: ''}, {name: '', phone: ''}, {name: '', phone: ''}, {name: '', phone: ''}] : [])
this.locateObj = this.setting.locateObj ? this.setting.locateObj : ''
if (this.deviceObj.dtype === 330 || this.deviceObj.dtype === 332) {
this.whiteList = this.setting.whiteList ? this.setting.whiteList : []
} else {
this.locateList = this.setting.locateList ? this.setting.locateList : []
this.notifyObj = this.setting.notifyObj ? this.setting.notifyObj : ''
}
},
getNotifyWay () {




let wayArr = []
this.deviceObj.notifytype.split('').forEach((item, index) => {
if (index === 0 && item === '1') {
wayArr.push('1')
} else if (index === 1 && item === '1') {
wayArr.push('2')
} else if (index === 2 && item === '1') {
wayArr.push('3')
}
})
return wayArr
},
getInitSelectNav () {
let result = ''
if (this.deviceObj.dtype === 312) {
result = 'locate'
} else {
result = 'addressBook'
}
return result
},

/* 按钮事件 */
notifyWayChange () {
let way = '000'
let notifyType = this.deviceObj.notifytype
this.notifyWay.forEach((item, index) => {
if (item === '1') {
way = '1' + way.slice(1)
} else if (item === '2') {
way = way.slice(0, 1) + '1' + way.slice(2)
} else if (item === '3') {
way = way.slice(0, 2) + '1'
}
})
notifyType = way + notifyType.slice(3)
this.sendDeviceNotify(notifyType)
},

openSetBook (flag, book, index) {
this.popupObj.type = 'addressBook'
this.popupObj.selectIdx = index
if (flag === 'add') {
if (this.deviceObj.dtype === 330 && this.addressBookList.length > 3) {
this.$toast('亲情号已达上限')
return
}
this.popupObj.flag = 1
this.popupObj.title = '新增电话'
this.popupObj.phoneObj = { name: '', phone: '', url: '', imNum: '' }
} else if (flag === 'edit') {
this.popupObj.flag = 2
this.popupObj.title = '编辑电话'
this.popupObj.phoneObj = this.clone(book)
} else if (flag === 'del') {
this.popupObj.flag = 3
this.popupObj.title = ''
this.popupObj.selectIdx = index
this.popupObj.phoneObj = this.clone(book)
}
this.popupShow = true
},

openSetClock (flag, clock, index) {
this.popupObj.type = 'alarmClock'
this.popupObj.selectIdx = index
if (flag === 'add') {
this.popupObj.flag = 1
this.popupObj.title = '新增闹钟'
this.popupObj.clockObj = {id: '', timeType: 'y', time: '', content: ''}
this.clockPeriodText = '按年'
this.clockPeriod = 0
this.clockDateText = ''
this.clockDate = ''
this.clockTime = ''
} else if (flag === 'edit') {
this.popupObj.flag = 2
this.popupObj.title = '编辑闹钟'
this.popupObj.clockObj = this.clone(clock)
if (this.deviceObj.dtype === 330 || this.deviceObj.dtype === 332) {
this.clockTime = this.popupObj.clockObj.time
} else {
let timeType = this.popupObj.clockObj.timeType
if (timeType === 'd') {
this.clockPeriodText = '按天'
this.clockPeriod = 2
this.clockDate = ''
this.clockDateText = ''
let times = this.popupObj.clockObj.time.split(':')
this.clockTime = times[0] + ':' + times[1]
} else {
let dates = this.popupObj.clockObj.time.split(' ')
let times = dates[1].split(':')
if (timeType === 'y') {
this.clockPeriodText = '按年'
this.clockPeriod = 0
this.clockDate = new Date(new Date().format('yyyy') + '-' + this.popupObj.clockObj.time)
this.clockDateText = dates[0]
this.clockTime = times[0] + ':' + times[1]
} else if (timeType === 'm') {
this.clockPeriodText = '按月'
this.clockPeriod = 1
this.clockDate = this.clockDayArr.findIndex(r => r.text === dates[0])
this.clockDateText = dates[0]
this.clockTime = times[0] + ':' + times[1]
} else if (timeType === 's') {
this.clockPeriodText = '只提醒一次'
this.clockPeriod = 3
this.clockDate = new Date(dates[0])
this.clockDateText = dates[0]
this.clockTime = times[0] + ':' + times[1]
}
}
}
} else if (flag === 'del') {
this.popupObj.flag = 3
this.popupObj.title = ''
this.popupObj.clockObj = this.clone(clock)
}
this.popupShow = true
},

clockPeriodConfirm (obj) {
this.clockPeriodText = obj.text
this.popupObj.clockObj.timeType = obj.value
this.clockDateText = ''
if (obj.value === 'y' || obj.value === 's') {
this.clockDate = new Date()
} else if (obj.value === 'm') {
this.clockDate = 0
} else if (obj.value === 'd') {
this.clockDate = ''
}
this.clockPeriodShow = false
},

clockDateClick () {
let timeType = this.popupObj.clockObj.timeType
if (timeType === 'y') {
this.clockDateYShow = true
} else if (timeType === 'm') {
this.clockDateMShow = true
} else if (timeType === 's') {
this.clockDateSShow = true
}
},
clockDateConfirm (event, type) {
if (type === 'y') {
this.clockDateText = event.format('MM-dd')
this.clockDateYShow = false
} else if (type === 'm') {
this.clockDateText = event.text
this.clockDateMShow = false
} else if (type === 's') {
this.clockDateText = event.format('yyyy-MM-dd')
this.clockDateSShow = false
}
},

clockTimeClick () {
this.clockTime = this.clockTime === '' ? '10:00' : this.clockTime
this.clockTimeShow = true
},
clockTimeConfirm (time) {
this.clockTime = time
this.clockTimeShow = false
},

openSetLocate (flag, locate, index, type) {
this.popupObj.type = 'locate'
this.popupObj.selectIdx = index
if (type === 1) {

this.popupObj.flag = 2
if (this.deviceObj.dtype === 330 || this.deviceObj.dtype === 332) {
this.popupObj.title = '设置定位间隔'
this.popupObj.locateObj = { type: 1, time: this.locateObj !== '' ? this.locateObj.time : '1' }
} else {
this.popupObj.title = '设置按次定位'
this.popupObj.locateObj = {
type: 1,
func: this.locateObj !== '' ? this.locateObj.func : 1, // 1 打开 -1 关闭
num: this.locateObj !== '' ? this.locateObj.num : '', // 定位次数
time: this.locateObj !== '' ? this.locateObj.time : '',
mode: this.locateObj !== '' ? this.locateObj.mode : 0
}
this.locateModelArr.forEach((locateModel, index) => {
if (locateModel.id === parseInt(this.locateObj.mode)) {
this.locateModeText = locateModel.text
this.locateMode = index
}
})
}
} else if (type === 2) {

if (flag === 'add') {
this.popupObj.flag = 1
this.popupObj.title = '新增按时定位'
this.popupObj.locateObj = {
type: 2,
func: 1, // 1 打开 -1 关闭
num: '', // 定位次数
time: '',
mode: 0,
startTime: '',
endTime: ''
}
this.locateModeText = ''
this.locateMode = 0
} else if (flag === 'del') {
this.popupObj.flag = 3
this.popupObj.title = ''
this.popupObj.locateObj = this.clone(locate)
this.popupObj.locateObj.type = 2
}
}
this.popupShow = true
},
locateStartTimeConfirm (time) {
this.popupObj.locateObj.startTime = time
this.popupObj.locateObj.endTime = ''
this.locateMinHour = time.split(':')[0]
this.locateStartTimeShow = false
},
locateEndTimeConfirm (time) {
this.popupObj.locateObj.endTime = time
this.locateEndTimeShow = false
},
locateModeConfirm (obj) {
this.locateModeText = obj.text
this.popupObj.locateObj.mode = obj.id
this.locateModeShow = false
},

openSetNotify () {
this.popupObj.type = 'notify'
this.popupObj.flag = 2
this.popupObj.title = '设置通知'
this.popupObj.notifyObj = {
type: this.notifyObj !== '' ? this.notifyObj.type : '1', // 1 闪屏消息。2 普通消息
title: this.notifyObj !== '' ? this.notifyObj.title : '',
content: this.notifyObj !== '' ? this.notifyObj.content : ''
}
this.popupShow = true
},

openSetSosPhone () {
this.popupObj.type = 'sosPhone'
this.popupObj.flag = 2
this.popupObj.title = '设置SOS号码'
let sosPhoneObj = this.addressBookList.length !== 0 ? this.addressBookList[0] : null
this.popupObj.phoneObj = {
phone: sosPhoneObj ? sosPhoneObj.phone : '',
name: sosPhoneObj ? sosPhoneObj.name : ''
}
this.popupShow = true
},

openSetPhone (index) {
let title = ''
if (index === 0) {
title = '设置SOS号码'
} else if (index === 1) {
title = '设置电话一号码'
} else if (index === 2) {
title = '设置电话二号码'
} else if (index === 3) {
title = '设置电话三号码'
}
this.popupObj.type = 'addressBook'
this.popupObj.flag = 2
this.popupObj.selectIdx = index
this.popupObj.title = title
this.popupObj.phoneObj = this.clone(this.addressBookList[index])
this.popupShow = true
},

openSetWhite (flag, white, index) {
this.popupObj.type = 'whiteList'
this.popupObj.selectIdx = index
if (flag === 'add') {
if (this.whiteList.filter(r => r.phone !== '').length >= 20) {
this.$toast('白名单已达上限')
return
}
this.popupObj.flag = 1
this.popupObj.title = '新增白名单'
this.popupObj.whiteObj = { phone: '', time: '0000-2359+0000-2359' }
} else if (flag === 'edit') {
this.popupObj.flag = 2
this.popupObj.title = '编辑白名单'
this.popupObj.whiteObj = this.clone(white)
} else if (flag === 'del') {
this.popupObj.flag = 3
this.popupObj.title = ''
this.popupObj.selectIdx = index
this.popupObj.whiteObj = this.clone(white)
}
this.popupShow = true
},

submitSetDevice () {
let flag = this.popupObj.flag
let popupType = this.popupObj.type
let arr = []
if (popupType === 'addressBook' || popupType === 'sosPhone') {
if (this.deviceObj.dtype === 330) {
arr = this.addressBookList.length === 0 ? [{phone: '', name: ''}] : this.clone(this.addressBookList)
} else {
arr = this.clone(this.addressBookList)
}
} else if (popupType === 'alarmClock') {
arr = this.clone(this.alarmClockList)
} else if (popupType === 'locate' && this.popupObj.locateObj.type === 2) {
arr = this.clone(this.locateList)
} else if (popupType === 'whiteList') {
if (this.whiteList.length === 0) {
for (let i = 0; i < 20; i++) {
arr.push({phone: '', time: '0000-2359+0000-2359'})
}
} else {
arr = this.clone(this.whiteList)
}
}

if (flag === 3) {

if (popupType === 'whiteList') {
arr[this.popupObj.selectIdx].phone = ''
} else {
arr = arr.filter((item, i) => i !== this.popupObj.selectIdx)
}
console.log(55555, arr)
} else {

if (popupType === 'addressBook') {
if (this.deviceObj.dtype !== 332 && !this.verifyPopupAddressBook()) {
return
}
if (this.popupObj.phoneObj.phone !== '' && arr.find(r => r.phone === this.popupObj.phoneObj.phone)) {
this.$toast('已有添加号码')
return
}
if (flag === 1) {
arr.push(this.popupObj.phoneObj)
} else if (flag === 2) {
arr[this.popupObj.selectIdx] = this.popupObj.phoneObj
}
} else if (popupType === 'alarmClock') {
if (!this.verifyPopupAlarmClock()) {
return
}
if (this.deviceObj.dtype === 330 || this.deviceObj.dtype === 332) {
this.popupObj.clockObj.time = this.clockTime
} else {
this.popupObj.clockObj.time = this.popupObj.clockObj.timeType === 'd' ? this.clockTime + ':00' : this.clockDateText + ' ' + this.clockTime + ':00'
}
if (flag === 1) {
arr.push(this.popupObj.clockObj)
} else if (flag === 2) {
arr[this.popupObj.selectIdx] = this.popupObj.clockObj
}
} else if (popupType === 'locate') {
if (!this.verifyPopupLocate()) {
return
}
if (this.popupObj.locateObj.type === 1) {
arr = [this.popupObj.locateObj]
} else if (this.popupObj.locateObj.type === 2) {
if (flag === 1) {
arr.push(this.popupObj.locateObj)
} else if (flag === 2) {
arr[this.popupObj.selectIdx] = this.popupObj.locateObj
}
}
} else if (popupType === 'notify') {
if (!this.verifyPopupNotify()) {
return
}
arr = [this.popupObj.notifyObj]
} else if (popupType === 'sosPhone') {
arr[0] = this.popupObj.phoneObj
} else if (popupType === 'whiteList') {
if (!this.verifyPopupWhiteList()) {
return
}
if (arr.find(r => r.phone === this.popupObj.whiteObj.phone)) {
this.$toast('已有添加号码')
return
}
if (flag === 1) {
let firstIdx = arr.findIndex(r => r.phone === '')
if (firstIdx !== -1) {
arr[firstIdx] = this.popupObj.whiteObj
} else {
arr.push(this.popupObj.whiteObj)
}
} else if (flag === 2) {
arr[this.popupObj.selectIdx] = this.popupObj.whiteObj
}
}
}
this.sendSetDevice(arr)
},
sendSetDevice (sendArr) {
let body = {
imei: this.deviceObj.deviceid,
did: this.deviceObj.id,
method: '',
command1: '',
reserved2: ''
}
let popupType = this.popupObj.type
if (popupType === 'addressBook') {
if (this.deviceObj.dtype === 330 || this.deviceObj.dtype === 332) {
body.method = 'normalbutton'
let command1 = ''
let command2 = ''
sendArr.forEach((item, index) => {
command1 += index !== 0 ? '|' + item.phone : item.phone
command2 += index !== 0 ? '|' + item.name : item.name
})
body.command1 = command1
body.command2 = command2
} else {
let command = ''
body.method = 'phonebook310'
sendArr.forEach(item => {
if (command === '') {
command = item.name + '|' + item.phone + '||'
} else {
command = command + '&' + item.name + '|' + item.phone + '||'
}
})
body.command1 = command
}
} else if (popupType === 'alarmClock') {
if (this.deviceObj.dtype === 330 || this.deviceObj.dtype === 332) {
body.method = 'setclock330'
let command = ''
sendArr.forEach(item => {
let times = item.time.split(':')
let weeks = ''
item.weeks.forEach(week => {
weeks += weeks === '' ? week : '+' + week
})
if (command !== '') {
command += '@'
}
command += item.id + '=' + times[0] + times[1] + '!' + weeks + '!' + item.type
})
body.command1 = command
} else {
let command = ''
body.method = 'setclock310'
sendArr.forEach((item, index) => {
if (command === '') {
command = (index + 1) + '#' + item.timeType + '#' + item.time + '#' + item.content + '#'
} else {
command = command + '|' + (index + 1) + '#' + item.timeType + '#' + item.time + '#' + item.content + '#'
}
})
body.command1 = command
}
} else if (popupType === 'locate') {
let command = ''
if (this.deviceObj.dtype === 330 || this.deviceObj.dtype === 332) {
body.method = 'setfrequencylocation'
command = sendArr[0].time
} else {
if (this.popupObj.locateObj.type === 1) {
body.method = 'requirelocation310'
command = sendArr[0].func + '|' + sendArr[0].num + '|' + sendArr[0].time + '|' + sendArr[0].mode
} else if (this.popupObj.locateObj.type === 2) {
body.method = 'requirelocationperiod310'
if (sendArr.length !== 0) {
sendArr.forEach(item => {
if (command === '') {
command = '2|' + item.startTime + '#' + item.endTime + '#' + item.time + '#' + item.mode
} else {
command = command + ';' + item.startTime + '#' + item.endTime + '#' + item.time + '#' + item.mode
}
})
} else {
command = '-2|'
}
}
}
body.command1 = command
} else if (popupType === 'notify') {
body.method = 'sendmessage310'
body.command1 = sendArr[0].type
body.command2 = sendArr[0].type === '2' ? sendArr[0].title : sendArr[0].content
if (sendArr[0].type === '2') {
body.command3 = sendArr[0].content
}
} else if (popupType === 'sosPhone') {
body.method = 'normalbutton'
let command1 = ''
let command2 = ''
sendArr.forEach((item, index) => {
command1 += index !== 0 ? '|' + item.phone : item.phone
command2 += index !== 0 ? '|' + item.name : item.name
})
body.command1 = command1
body.command2 = command2
} else if (popupType === 'whiteList') {
body.method = 'phonein330'
let command1 = ''
sendArr.forEach(item => {
if (command1 !== '') {
command1 += '!'
}
command1 += item.phone + '=' + item.time
})
body.command1 = command1
}

if (body.method !== '') {
this.sendDeviceCommand(body, sendArr)
}
},

/* UI */
getClockTimeShow (item) {
let times = item.time.split(' ')
if (item.timeType === 'm') {
return times[0] + '号' + ' ' + times[1]
} else {
return item.time
}
},
getClockTypeColor (type) {
if (type === 'y') {
return '#6591FC'
} else if (type === 'm') {
return '#FFA41D'
} else if (type === 'd') {
return '#FF5035'
} else if (type === 's') {
return '#42BF4B'
} else {
return '#e8e8e8'
}
},
getLocateModeShow (mode) {
let model = this.locateModelArr.find(r => r.id === parseInt(mode))
return model ? model.text : mode
},
formatter (type, val) {
if (type === 'year') {
return `${val}年`
} else if (type === 'month') {
return `${val}月`
} else if (type === 'day') {
return `${val}日`
}
return val
},
getWeekName (week) {
let name = week
if (week === 0) {
name = '周日'
} else if (week === 1) {
name = '周一'
} else if (week === 2) {
name = '周二'
} else if (week === 3) {
name = '周三'
} else if (week === 4) {
name = '周四'
} else if (week === 5) {
name = '周五'
} else if (week === 6) {
name = '周六'
}
return name
},

verifyPopupAddressBook () {
let result = true
if (this.popupObj.phoneObj.phone === '') {
this.$toast('请输入电话')
result = false
} else if (this.popupObj.phoneObj.name === '') {
this.$toast('请输入姓名')
result = false
}
return result
},
verifyPopupAlarmClock () {
let result = true
if (this.deviceObj.dtype === 330 || this.deviceObj.dtype === 332) {
if (this.popupObj.clockObj.weeks.length === 0) {
this.$toast('请选择周期')
result = false
} else if (this.clockTime === '') {
this.$toast('请选择提醒时间')
result = false
}
} else {
if (this.popupObj.clockObj.content === '') {
this.$toast('请输入提醒内容')
result = false
} else if (this.popupObj.clockObj.timeType !== 'd' && this.clockDateText === '') {
this.$toast('请选择提醒日期')
result = false
} else if (this.clockTime === '') {
this.$toast('请选择提醒时间')
result = false
}
}
return result
},
verifyPopupLocate () {
let result = true
if (this.deviceObj.dtype === 330 || this.deviceObj.dtype === 332) {
if (this.popupObj.locateObj.time === '') {
this.$toast('请输入定位间隔')
result = false
}
} else {
let type = this.popupObj.locateObj.type
if (type === 1 && this.popupObj.locateObj.num === '') {
this.$toast('请输入定位次数')
result = false
} else if (type === 2 && this.popupObj.locateObj.startTime === '') {
this.$toast('请选择开始时间')
result = false
} else if (type === 2 && this.popupObj.locateObj.endTime === '') {
this.$toast('请选择结束时间')
result = false
} else if (this.popupObj.locateObj.time === '') {
this.$toast('请输入定位间隔')
result = false
} else if (this.popupObj.locateObj.mode === '') {
this.$toast('请选择定位模式')
result = false
}
}
return result
},
verifyPopupNotify () {
let result = true
if (this.popupObj.notifyObj.type === 2 && this.popupObj.notifyObj.title === '') {
this.$toast('请输入通知标题')
result = false
} else if (this.popupObj.notifyObj.content === '') {
this.$toast('请输入通知内容')
result = false
}
return result
},
verifyPopupWhiteList () {
let result = true
if (this.popupObj.whiteObj.phone === '') {
this.$toast('请输入号码')
result = false
}
return result
},

/* 访问接口 */
sendDeviceNotify (notifyType) {
let data = {
phone: this.$store.getters.get_user,
did: this.deviceObj.id,
notifytype: notifyType
}
setdevicenotifytype(data).then(res => {
if (res.code === 200) {
this.deviceObj.notifytype = notifyType
this.$store.commit('set_child_obj', this.deviceObj)
this.$toast('成功')
} else {
this.notifyWay = this.getNotifyWay()
this.$toast('失败')
}
}).catch(() => {
this.notifyWay = this.getNotifyWay()
this.$toast('失败')
})
},
sendDeviceCommand (body, sendArr) {
console.log('body:', body, 'sendArr:', sendArr)
sendcommandmessage(body).then(res => {
if (res.code === 200) {
this.$toast('成功')
let popupType = this.popupObj.type
if (popupType === 'addressBook' || popupType === 'sosPhone') {
this.addressBookList = sendArr
this.setting.addressBookList = sendArr
} else if (popupType === 'alarmClock') {
this.alarmClockList = sendArr
this.setting.alarmClockList = sendArr
} else if (popupType === 'locate') {
if (this.popupObj.locateObj.type === 1) {
this.locateObj = sendArr[0]
this.setting.locateObj = sendArr[0]
} else if (this.popupObj.locateObj.type === 2) {
this.locateList = sendArr
this.setting.locateList = sendArr
}
} else if (popupType === 'notify') {
this.notifyObj = sendArr[0]
this.setting.notifyObj = sendArr[0]
} else if (popupType === 'whiteList') {
this.whiteList = sendArr
this.setting.whiteList = sendArr
}
this.$store.commit('set_child_obj', this.deviceObj)
this.popupShow = false
} else {
this.$toast('失败')
}
}).catch(() => {})
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/childSetWatch.vue